import pathToRegexp from 'path-to-regexp/index';

/**
 * Used to check if a given location belongs to a path.
 * Meant to be used for checking react-router-dom paths.
 * @param {String} location The current location (ex: /users/1)
 * @param {String} path The current path (ex: /users/:id)
 * @returns {boolean} Returns true if the location belongs to the path
 */
export const locationInPath = (location, path) => {
  const re = pathToRegexp(path);
  return !!re.exec(location);
};
export default {
  locationInPath
};